import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { teamContent } from '../../data/homeContent';

const TeamMember = ({ name, role, description, gradient }) => (
  <div
    className={`
      group relative bg-white rounded-2xl shadow-xl p-6 text-center transition-transform duration-300
      hover:scale-105 hover:shadow-2xl
      before:absolute before:inset-0 before:rounded-2xl before:z-[-1]
      before:opacity-0 before:transition-opacity before:duration-300
      hover:before:opacity-100
    `}
    style={{
      overflow: 'visible',
    }}
  >
    <div
      className={`
        w-24 h-24 mx-auto mb-4 rounded-full flex items-center justify-center
        bg-gradient-to-tr ${gradient} shadow-lg
        ring-4 ring-white group-hover:ring-8 group-hover:ring-opacity-40 transition-all duration-300
        animate-fadeIn
      `}
    >
      <UserOutlined className="text-4xl text-white drop-shadow-lg" />
    </div>
    <h3 className="text-2xl font-extrabold mb-1 text-gray-800 group-hover:text-blue-700 transition-colors duration-300">{name}</h3>
    <h4 className="text-blue-600 font-semibold mb-2 group-hover:text-indigo-600 transition-colors duration-300">{role}</h4>
    <p className="text-gray-600 group-hover:text-gray-800 transition-colors duration-300">{description}</p>
    <div className="absolute -top-4 -right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
      <svg width="32" height="32" fill="none"><circle cx="16" cy="16" r="16" fill="#6366F1" fillOpacity="0.2"/></svg>
    </div>
  </div>
);

const Team = () => {
  const { title, subtitle, members } = teamContent;

  return (
    <div className="py-20 bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 animate-fadeIn">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4">{title}</h2>
        <p className="text-xl text-gray-600 text-center mb-12">{subtitle}</p>
        <div className="grid md:grid-cols-2 gap-8">
          {members.map((member, index) => (
            <TeamMember key={index} {...member} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team; 